var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartiallyCompletedSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 24L33.3818 21.0667L33.7091 17.1905L29.7818 16.3524L27.7091 13L24 14.5714L20.2909 13L18.2182 16.3524L14.2909 17.1905L14.6182 21.0667L12 24L14.6182 26.9333L14.2909 30.8095L18.2182 31.6476L20.2909 35L24 33.4286L27.7091 35L29.7818 31.6476L33.7091 30.8095L33.3818 26.9333L36 24ZM31.3091 29.1333L28.3636 29.7619L26.8364 32.2762L24 31.1238L21.1636 32.2762L19.6364 29.7619L16.6909 29.1333L16.9091 26.2L14.9455 24L16.9091 21.8L16.6909 18.8667L19.6364 18.2381L21.1636 15.7238L24 16.8762L26.8364 15.7238L28.3636 18.2381L31.3091 18.8667L31.0909 21.8L33.0545 24L31.0909 26.2L31.3091 29.1333ZM29.0182 19.3905L30.5455 20.8571L21.8182 29.2381L17.4545 25.0476L18.9818 23.581L21.8182 26.3048L29.0182 19.3905Z",
    fill: "#848587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiallyCompletedSupplyReqIcon);
export default __webpack_public_path__ + "static/media/partially-completed-supply-req-icon.9a624db89d8d4cbd01bc9ca65fb7263d.svg";
export { ForwardRef as ReactComponent };